module.exports = __webpack_public_path__ + "static/media/play-endgame.e836e814.png";